import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var VatIssueIA = function VatIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "41zbB/",
    defaultMessage: [{
      "type": 0,
      "value": "Nos casos das encomendas com envio transfronteiriço dentro da UE, a Faire cobra o IVA no check-out com base no país para o qual vão ser enviadas. Se o revendedor não tiver facultado um número de IVA, pode tomar estes passos:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "N1WrAx",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Enviar uma mensagem ao revendedor:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "vd648L",
    defaultMessage: [{
      "type": 0,
      "value": "Utilize o "
    }, {
      "children": [{
        "type": 0,
        "value": "sistema de mensagens da Faire"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " para contactar diretamente o revendedor e saber se este tem um número de IVA registado para comércio intracomunitário. Se o revendedor confirmar que tem um número de IVA para comércio intracomunitário, peça-lhe que o adicione às definições da respetiva conta na Faire para garantir que o IVA é aplicado da forma correta. Isto deve resultar na aplicação de 0% de IVA às encomendas não processadas de marcas da UE."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "LokvZV",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Adiar o processamento:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "eFvj9E",
    defaultMessage: [{
      "type": 0,
      "value": "Considere adiar o envio da encomenda até que o revendedor tenha a oportunidade de adicionar o número de IVA à respetiva conta. Para consultar orientações mais detalhadas, aceda a "
    }, {
      "children": [{
        "type": 0,
        "value": "Como funciona o IVA para encomendas na UE"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "?"
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return HCFormatting(chunks);
      }
    }
  })))));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var HCFormatting = function HCFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360057747911"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};